// redux
export const CLEAR_COMPONENT_API_RESPONSE = 'editor/CLEAR_COMPONENT_API_RESPONSE';
export const CLEAR_CONTAINER = 'editor/CLEAR_CONTAINER';
export const COMPONENT_MODIFIED = 'editor/COMPONENT_MODIFIED';

export const COMPONENT_SAVE_REQUESTED = 'editor/COMPONENT_SAVE_REQUESTED';
export const COMPONENT_SAVE_FULFILLED = 'editor/COMPONENT_SAVE_FULFILLED';
export const COMPONENT_SAVE_REJECTED = 'editor/COMPONENT_SAVE_REJECTED';
export const IS_FETCHING_COMPONENT = 'editor/IS_FETCHING_COMPONENT';

export const UNPUBLISH_COMPONENT_REQUESTED = 'editor/UNPUBLISH_COMPONENT_REQUESTED';
export const UNPUBLISH_COMPONENT_FULFILLED = 'editor/UNPUBLISH_COMPONENT_FULFILLED';
export const UNPUBLISH_COMPONENT_REJECTED = 'editor/UNPUBLISH_COMPONENT_REJECTED';

export const DYNAMIC_VALUES_FULFILLED = 'contract/DYNAMIC_VALUES_FULFILLED';
export const DYNAMIC_VALUES_REJECTED = 'contract/DYNAMIC_VALUES_REJECTED';
export const DYNAMIC_VALUES_REQUESTED = 'contract/DYNAMIC_VALUES_REQUESTED';

// contract types
export const ARRAY_TYPE = 'array';
export const FIELD_TYPE = 'field';
